import { render } from "./PlayerPointsCard.vue?vue&type=template&id=0d410b35&scoped=true"
import script from "./PlayerPointsCard.vue?vue&type=script&lang=js"
export * from "./PlayerPointsCard.vue?vue&type=script&lang=js"

import "./PlayerPointsCard.vue?vue&type=style&index=0&id=0d410b35&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d410b35"]])

export default __exports__